import { ISolicitudStandByModel } from "../interfaces/solicitud/ISolicitudStandByModel";

export class SolicitudStandByModel implements ISolicitudStandByModel {
    idSolicitud : number;
    comentarios: string;

    constructor(){
        this.idSolicitud = 0;
        this.comentarios = '';
    }
}